// extracted by mini-css-extract-plugin
module.exports = {"inviteText":"InviteStartupModal_inviteText__1Ni6i","email":"InviteStartupModal_email__22q1A"};